import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IAddon, IPaginatedResponse } from "../../interfaces";

export const useAvailableAddons = () => {
  return useQuery<IAddon[], Error>({
    queryKey: ["billing", "addons"],
    queryFn: async () => {
      const response = await httpService.get<IAddon[] | IPaginatedResponse<IAddon>>(
        API_CONFIG.path.billingAddons
      );
      return Array.isArray(response) ? response : (response as IPaginatedResponse<IAddon>).results ?? [];
    },
  });
};
